export interface AIModel {
  algModelTypeName?: string;
  algModelType?: string;
  avatar?: string;
  businessId?: number;
  businessType?: string;
  createUserName?: string;
  cover?: string;
  openType?: string;
  openTypeName?: string;
  runTotalCount?: number;
  title?: string;
  visibleStatus?: ModelVisibility | undefined;
}

export interface YushengVoice {
  age: string;
  desc: string;
  emotion: Array<string>;
  emotionIntensity: number;
  emotionMaxMapping: number;
  exampleSentence: string;
  gender: string;
  group: string;
  name: string;
  speakerId: string;
  tags: Array<string>;
  visibleStatus?: ModelVisibility | undefined;
}

export enum ModelVisibility {
  Visible = 1,
  Invisible = 0,
  All = 99999999,
}
